const ARTICLES = 'ARTICLES';
const ONBOARDINGS = 'ONBOARDINGS';
const KNOWLEDGE_LIBRARIES = 'KNOWLEDGE_LIBRARIES';

export const defaultTranslations = {
  en: {
    ARTICLES: 'Magazine',
    FEED: 'Feed',
    KNOWLEDGE_LIBRARIES: 'Libraries',
    ONBOARDINGS: 'Onboarding',
    TIME_OFF: 'Time off',
    GOALS: 'Goals',
    PEOPLE_EXPERIENCE: 'People experience',
  },
  es: {
    ARTICLES: 'Noticias',
    FEED: 'Muro',
    KNOWLEDGE_LIBRARIES: 'Librerías',
    ONBOARDINGS: 'Onboarding',
    TIME_OFF: 'Vacaciones y permisos',
    GOALS: 'Objetivos',
    PEOPLE_EXPERIENCE: 'People experience',
  },
  pt: {
    ARTICLES: 'Notícias',
    FEED: 'Mural',
    KNOWLEDGE_LIBRARIES: 'Bibliotecas',
    ONBOARDINGS: 'Onboarding',
    TIME_OFF: 'Tempo livre',
    GOALS: 'Objetivos',
    PEOPLE_EXPERIENCE: 'People experience',
  },
};

export const defaultTranslationsWithNoInformation = {
  en: {
    NO_ARTICLES: 'No articles',
    NO_ONBOARDINGS: `No onboarding processes assigned yet. Once assigned, you'll find them here`,
    NO_KNOWLEDGE_LIBRARIES: 'No knowledge libraries available',
  },
  es: {
    NO_ARTICLES: 'No hay artículos',
    NO_ONBOARDINGS:
      'No tienes ningún proceso de onboarding asignado. En cuanto se te asigne aquí encontrarás el mismo',
    NO_KNOWLEDGE_LIBRARIES: 'No hay librerías de conocimiento disponibles',
  },
  pt: {
    NO_ARTICLES: 'Não há artigos',
    NO_ONBOARDINGS:
      'Nenhum processo de onboarding atribuído ainda. Uma vez atribuído, você o encontrará aqui',
    NO_KNOWLEDGE_LIBRARIES: 'Nenhuma biblioteca disponível',
  },
};

export const translationsWithNoInformation = (nameSpace, nameNewModule) => {
  if (nameSpace === ARTICLES) {
    return {
      en: {
        NO_ARTICLES: `There aren't any ${nameNewModule} to show yet.`,
      },
      es: {
        NO_ARTICLES: `Por ahora no hay ${nameNewModule} para mostrar.`,
      },
      pt: {
        NO_ARTICLES: `Ainda não há ${nameNewModule} para mostrar.`,
      },
    };
  }
  if (nameSpace === ONBOARDINGS) {
    return {
      en: {
        NO_ONBOARDINGS: `No ${nameNewModule} processes assigned yet. Once assigned, you'll find them here`,
      },
      es: {
        NO_ONBOARDINGS: `No tienes ningún proceso de ${nameNewModule} asignado. En cuanto se te asigne aquí encontrarás el mismo`,
      },
      pt: {
        NO_ONBOARDINGS: `Nenhum processo de ${nameNewModule} atribuído ainda. Uma vez atribuído, você o encontrará aqui`,
      },
    };
  }
  if (nameSpace === KNOWLEDGE_LIBRARIES) {
    return {
      en: {
        NO_KNOWLEDGE_LIBRARIES: `No ${nameNewModule} available`,
      },
      es: {
        NO_KNOWLEDGE_LIBRARIES: `No hay ${nameNewModule} disponibles`,
      },
      pt: {
        NO_KNOWLEDGE_LIBRARIES: `Nenhuma ${nameNewModule} disponível`,
      },
    };
  }
  return null;
};

export const nameSpacesWithCustomTitles = [
  'ARTICLES',
  'FEED',
  'KNOWLEDGE_LIBRARIES',
  'ONBOARDINGS',
  'TIME_OFF',
];
export const nameSpacesWithNoInformationTitles = [
  'ARTICLES',
  'KNOWLEDGERKNOWLEDGE_LIBRARIES',
  'ONBOARDINGS',
];
